<template>
  <b-modal no-fade v-model="dialog.show" size="lg"  :id="`modal-campaign-${uniqueId}`"
           :hide-footer="true" centered @close="onDialogClose"
           no-close-on-backdrop :title="$t('tabs.campaigns.details')"


  >
    <template #modal-title>
     <span v-if="loading !== true && error == null && campaign != null && campaign.id != null">
       {{ campaign.email }}
     </span>
    </template>
    <div style="min-height: 600px">
      <div v-if="loading !== true && error == null">
        <campaign-edit-details v-bind:new-campaign="isNewCampaign" v-model="campaign" @close="closeModal" />
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else-if="loading !== true && error != null">
        <b-alert show variant="danger" >
          <i class="fa-sharp fa-solid fa-triangle-exclamation"></i>
          {{ error }}
        </b-alert>
      </div>
      <div class="text-center position-absolute d-block w-100" style="top:50%" v-else>
        <b-spinner>{{$t('operations.loading')}}</b-spinner>
      </div>
    </div>
  </b-modal>
</template>

<script>
import mixinBase from '@/components/mixin/mixinBase'
import mixinNotifications from '@/components/mixin/mixinNotifications'
import { mapActions } from 'vuex'
import CampaignEditDetails from '@/components/partial/campaigns/CampaignEditDetails'
import Campaign from '@/model/campaign/Campaign'

export default {
  name: 'campaignModal',
  components: { CampaignEditDetails },
  mixins: [mixinBase, mixinNotifications],
  data: () => ({
    dialog: {
      show: false,
    },
    uniqueId: 0,
    loading: true,
    error: null,
    id: null,
    isNewCampaign: false,
    campaign: {}
  }),
  watch: {
    queryParams:{
      handler(){
        if(this.queryParams().campaignId == null) {
          this.closeModal()
          return
        }
        if (this.queryParams().campaignId !== this.id) {
          this.showModal(this.queryParams().campaignId)
        }
      },
      deep: true
    }
  },
  created() {
    this.uniqueId = this._uid
    if(this.queryParams().campaignId != null) {
      this.showModal(this.queryParams().campaignId)
    }
  },
  methods: {
    ...mapActions('campaign', ['getCampaignById']),
    showModal(id) {
      this.id = id
      this.loading = true
      this.dialog.show = true
      this.dialog.tab = 0
      this.isNewCampaign = this.id == null || this.id === 0;
      if(!this.isNewCampaign) {
        this.refreshData()
      }else {
        this.campaign = Campaign()
        this.error = null
        this.loading = false
      }
      this.pushState({campaignId: id, tab: 0, })
    },
    closeModal(){
      this.dialog.show = false;
      this.campaign = {}
      this.onDialogClose()
    },
    onDialogClose(){
      this.id = null;
      this.pushState({campaignId: null, tab: null, })
    },
    refreshData() {
      let $this = this;
      this.getCampaignById(this.id)
          .then(campaign => {
            $this.campaign = campaign;
            $this.error = null
            $this.loading = false
          }, err => {
            $this.error = $this.getErrorDescription(err)
            $this.loading = false
          })
    },
  }
}
</script>

<style scoped>

</style>
